import { MAX_FILE_SIZE_25_MB } from 'constants/common'
import { ACCEPT_DOCUMENT_TYPES } from 'features/ContractDetails/ExtendContract/constants'

export const UPLOAD_DOCUMENT_CONFIG = {
  accept: ACCEPT_DOCUMENT_TYPES,
  multiple: false,
  maxSize: MAX_FILE_SIZE_25_MB
}
